import { render, staticRenderFns } from "./LifterBigScreen.vue?vue&type=template&id=d2d3ccb6&scoped=true&"
import script from "./LifterBigScreen.vue?vue&type=script&lang=js&"
export * from "./LifterBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./LifterBigScreen.vue?vue&type=style&index=0&id=d2d3ccb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d3ccb6",
  null
  
)

export default component.exports